import * as React from 'react';

import {
    Props,
} from 'one-ui';

export interface CardProps extends Props {
    copyright?: string;
    version?: string;
}
export const Copyright = ({
    copyright = "© 2023, SpinSci Technologies LLC, All rights reserved",
    version
}: CardProps): JSX.Element => {

    return (
        <>
        <div className="copyleft">
        version {version}
        </div>
        <div className="copyright">
        {copyright}
      </div>
      </>
    );
}
